<template>
  <div class="RouteContainer pb-5">
    <app-background :backgroundImg="'./static/images/' + sharedContent.backgroundImgBlur"></app-background>
    <div class="container">

      <div class="row">
        <div class="col-lg-8 mx-auto mt-3">
          <div class="Blurb text-center text-lg-left">{{ localContent[0].intro }}</div>
        </div>
      </div>

      <div class="row">
        
        <!-- card one -->
        <div class="col-lg-4 mt-3">
          <img :src="'./static/images/takeAction/' + localContent[1].cards[0].image.fileName" :alt="localContent[1].cards[0].image.title">
          <div class="Blurb Blurb--dark mt-3">
            <h2 class="Card-title">{{ localContent[1].cards[0].title }}</h2>

            <h3 class="Card-subheading mt-3">{{ localContent[1].cards[0].subheadings[0] }}</h3>
            <p class="text-center text-lg-left">Visit us at <a :href="localContent[1].cards[0].socialLinks[0]" class="LinkInline" target="_blank" rel="noopener">livingwithwolves.org</a> and follow us on <a class="LinkInline" :href="localContent[1].cards[0].socialLinks[1]" target="_blank" rel="noopener">Facebook</a>, <a class="LinkInline" :href="localContent[1].cards[0].socialLinks[2]" target="_blank" rel="noopener">Instagram</a>, <a class="LinkInline" :href="localContent[1].cards[0].socialLinks[3]" target="_blank" rel="noopener">Twitter</a> for news, important information, and answers to your questions. We dispel myths and share clear facts about the importance of wolves in our world, and the threats that they face.</p>

            <a :href="localContent[1].cards[0].buttons[0].link" target="_blank" rel="noopener">
              <button class="Button Button--dark mt-3 mx-auto">{{ localContent[1].cards[0].buttons[0].text }}</button>
            </a>

            <!-- social icons list -->
            <ul class="Blurb-list Social-list mt-3 mx-auto">
              <a :href="localContent[1].cards[0].socialLinks[1]" target="_blank" rel="noopener">
                <li class="Social-list-item">
                  <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47" xml:space="preserve">
                    <g id="icon-wrapper--fb">
                      <g>
                        <path d="M5.7,46C3.1,46,1,43.9,1,41.3V5.7C1,3.1,3.1,1,5.7,1h35.7C43.9,1,46,3.1,46,5.7v35.7c0,2.6-2.1,4.7-4.7,4.7H5.7z"/>
                        <path fill="#FFFFFF" d="M41.3,2c2,0,3.7,1.6,3.7,3.7v35.7c0,2-1.6,3.7-3.7,3.7H5.7c-2,0-3.7-1.6-3.7-3.7V5.7C2,3.6,3.6,2,5.7,2
                          H41.3 M41.3,0H5.7C2.5,0,0,2.5,0,5.7v35.7C0,44.5,2.5,47,5.7,47h35.7c3.1,0,5.7-2.5,5.7-5.7V5.7C47,2.5,44.5,0,41.3,0L41.3,0z"/>
                      </g>
                    </g>
                    <g id="facebook">
                      <path class="icon" fill="#FFFFFF" d="M26,18.5v-3c0-1.3,0.3-2,2.4-2H31v-5h-4c-5,0-7,3.3-7,7v3h-4v5h4v15h6v-15h4.4l0.6-5H26z"/>
                    </g>
                  </svg>
                </li>
              </a>
              <a :href="localContent[1].cards[0].socialLinks[2]" target="_blank" rel="noopener">
                <li class="Social-list-item">
                  <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47" xml:space="preserve">
                    <g id="icon-wrapper--instagram">
                      <g>
                        <path d="M5.7,46C3.1,46,1,43.9,1,41.3V5.7C1,3.1,3.1,1,5.7,1h35.7C43.9,1,46,3.1,46,5.7v35.7c0,2.6-2.1,4.7-4.7,4.7H5.7z"/>
                        <path fill="#FFFFFF" d="M41.3,2c2,0,3.7,1.6,3.7,3.7v35.7c0,2-1.6,3.7-3.7,3.7H5.7c-2,0-3.7-1.6-3.7-3.7V5.7C2,3.6,3.6,2,5.7,2
                          H41.3 M41.3,0H5.7C2.5,0,0,2.5,0,5.7v35.7C0,44.5,2.5,47,5.7,47h35.7c3.1,0,5.7-2.5,5.7-5.7V5.7C47,2.5,44.5,0,41.3,0L41.3,0z"/>
                      </g>
                    </g>
                      <g id="instagram">
                        <g display="inline">
                          <path class="icon" fill="#FFFFFF" d="M23.5,12.8c3.5,0,3.9,0,5.3,0.1c1.3,0.1,2,0.3,2.4,0.4c0.6,0.2,1.1,0.5,1.5,1c0.4,0.4,0.8,0.9,1,1.5
                            c0.2,0.5,0.4,1.1,0.4,2.4c0.1,1.4,0.1,1.8,0.1,5.3s0,3.9-0.1,5.3c-0.1,1.3-0.3,2-0.4,2.4c-0.4,1.1-1.3,2-2.5,2.5
                            c-0.5,0.2-1.1,0.4-2.4,0.4c-1.4,0.1-1.8,0.1-5.3,0.1s-3.9,0-5.3-0.1c-1.3-0.1-2-0.3-2.4-0.4c-0.6-0.2-1.1-0.5-1.5-1
                            c-0.4-0.4-0.8-0.9-1-1.5c-0.2-0.5-0.4-1.1-0.4-2.4c-0.1-1.4-0.1-1.8-0.1-5.3s0-3.9,0.1-5.3c0.1-1.3,0.3-2,0.4-2.4
                            c0.2-0.6,0.5-1.1,1-1.5c0.4-0.4,0.9-0.8,1.5-1c0.5-0.2,1.1-0.4,2.4-0.4C19.6,12.9,20,12.8,23.5,12.8 M23.5,10.5
                            c-3.5,0-4,0-5.4,0.1c-1.4,0.1-2.3,0.3-3.2,0.6c-0.9,0.3-1.7,0.8-2.3,1.5c-0.7,0.6-1.2,1.4-1.5,2.3c-0.3,0.8-0.5,1.8-0.6,3.2
                            c-0.1,1.4-0.1,1.8-0.1,5.4s0,4,0.1,5.4c0.1,1.4,0.3,2.3,0.6,3.2c0.3,0.9,0.8,1.7,1.5,2.3c0.6,0.7,1.4,1.2,2.3,1.5
                            c0.8,0.3,1.8,0.5,3.2,0.6c1.4,0.1,1.8,0.1,5.4,0.1s4,0,5.4-0.1c1.4-0.1,2.3-0.3,3.2-0.6c1.7-0.7,3.1-2.1,3.8-3.8
                            c0.3-0.8,0.5-1.8,0.6-3.2c0.1-1.4,0.1-1.8,0.1-5.4s0-4-0.1-5.4c-0.1-1.4-0.3-2.3-0.6-3.2c-0.3-0.9-0.8-1.7-1.5-2.3
                            c-0.6-0.7-1.4-1.2-2.3-1.5c-0.8-0.3-1.8-0.5-3.2-0.6C27.5,10.5,27,10.5,23.5,10.5L23.5,10.5L23.5,10.5z"/>
                          <path class="icon" fill="#FFFFFF" d="M23.5,16.8c-3.7,0-6.7,3-6.7,6.7s3,6.7,6.7,6.7s6.7-3,6.7-6.7l0,0C30.2,19.8,27.2,16.8,23.5,16.8z
                            M23.5,27.8c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3C27.8,25.9,25.9,27.8,23.5,27.8z"/>
                          <circle class="icon" fill="#FFFFFF" cx="30.4" cy="16.6" r="1.6"/>
                        </g>
                      </g>
                    </svg>
                </li>
              </a>
              <a :href="localContent[1].cards[0].socialLinks[3]" target="_blank" rel="noopener">
                <li class="Social-list-item">
                  <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47" xml:space="preserve">
                    <g id="icon-wrapper--twitter">
                      <g>
                        <path d="M5.7,46C3.1,46,1,43.9,1,41.3V5.7C1,3.1,3.1,1,5.7,1h35.7C43.9,1,46,3.1,46,5.7v35.7c0,2.6-2.1,4.7-4.7,4.7H5.7z"/>
                        <path fill="#FFFFFF" d="M41.3,2c2,0,3.7,1.6,3.7,3.7v35.7c0,2-1.6,3.7-3.7,3.7H5.7c-2,0-3.7-1.6-3.7-3.7V5.7C2,3.6,3.6,2,5.7,2
                          H41.3 M41.3,0H5.7C2.5,0,0,2.5,0,5.7v35.7C0,44.5,2.5,47,5.7,47h35.7c3.1,0,5.7-2.5,5.7-5.7V5.7C47,2.5,44.5,0,41.3,0L41.3,0z"/>
                      </g>
                    </g>
                    <g id="twitter">
                      <g id="layer1" transform="translate(-539.17946,-568.85777)" display="inline">
                        <path id="path3611" class="icon" fill="#FFFFFF" d="M557.9,602.9c9.8,0,15.2-8.1,15.2-15.2c0-0.2,0-0.5,0-0.7c1-0.8,1.9-1.7,2.7-2.8
                          c-1,0.4-2,0.7-3.1,0.8c1.1-0.7,1.9-1.7,2.3-3c-1,0.6-2.2,1.1-3.4,1.3c-1-1-2.4-1.7-3.9-1.7c-2.9,0-5.3,2.4-5.3,5.3
                          c0,0.4,0,0.8,0.1,1.2c-4.4-0.2-8.4-2.3-11-5.6c-0.5,0.8-0.7,1.7-0.7,2.7c0,1.9,0.9,3.5,2.4,4.4c-0.9,0-1.7-0.3-2.4-0.7
                          c0,0,0,0,0,0.1c0,2.6,1.8,4.7,4.3,5.2c-0.4,0.1-0.9,0.2-1.4,0.2c-0.3,0-0.7,0-1-0.1c0.7,2.1,2.6,3.7,5,3.7
                          c-1.8,1.4-4.1,2.3-6.6,2.3c-0.4,0-0.9,0-1.3-0.1C552,602,554.8,602.9,557.9,602.9"/>
                      </g>
                    </g>
                  </svg>
                </li>
              </a>
            </ul>

            <h3 class="Card-subheading mt-5">{{ localContent[1].cards[0].subheadings[1] }}</h3>
            <p class="text-center text-lg-left">Read our books and watch our documentaries to learn more about wolves and the Sawtooth Pack.</p>
            <a :href="localContent[1].cards[0].buttons[1].link" target="_blank" rel="noopener">
              <button class="Button Button--dark mt-3 mx-auto">{{ localContent[1].cards[0].buttons[1].text }}</button>
            </a>

            <h3 class="Card-subheading mt-5">{{ localContent[1].cards[0].subheadings[2] }}</h3>
            <p class="text-center text-lg-left">Download our wolf educator guide for use in formal classrooms, museums, or at home. The activity guide is geared toward grades K-12 and the activities relate back to common core standards. The guide was created by Living with Wolves and National Geographic.</p>
            <a :href="localContent[1].cards[0].buttons[2].link" target="_blank" rel="noopener">
              <button class="Button Button--dark mt-3 mx-auto">{{ localContent[1].cards[0].buttons[2].text }}</button>
            </a>

            <h3 class="Card-subheading mt-5">{{ localContent[1].cards[0].subheadings[3] }}</h3>
            <p class="text-center text-lg-left">Purchase prints of the beautiful photos you see on this site from our partner, National Geographic Creative.</p>
            <a :href="localContent[1].cards[0].buttons[3].link" target="_blank" rel="noopener">
              <button class="Button Button--dark mt-3 mx-auto">{{ localContent[1].cards[0].buttons[3].text }}</button>
            </a>
            
          </div>
        </div>
        <!-- end card one -->

        <!-- card two -->
        <div class="col-lg-4 mt-3">
          <img :src="'./static/images/takeAction/' + localContent[1].cards[1].image.fileName" :alt="localContent[1].cards[1].image.title">
          <div class="Blurb Blurb--dark mt-3">
            <h2 class="Card-title">{{ localContent[1].cards[1].title }}</h2>
            <h3 class="Card-subheading mt-3">{{ localContent[1].cards[1].subheadings[0] }}</h3>
            <p class="Blurb-body text-center text-lg-left">{{ localContent[1].cards[1].description }}</p>

            <ul class="Blurb-list">
              <li class="Blurb-list-item--block">{{ localContent[1].cards[1].actions[0] }}</li>
              <li class="Blurb-list-item--block">{{ localContent[1].cards[1].actions[1] }}</li>
            </ul>

            <a :href="localContent[1].cards[1].button.link" target="_blank" rel="noopener">
              <button class="Button Button--dark mt-3 mx-auto">{{ localContent[1].cards[1].button.text }}</button>
            </a>

          </div>
        </div>
        <!-- end card two -->

        <!-- card three -->
        <div class="col-lg-4 mt-3">
          <img :src="'./static/images/takeAction/' + localContent[1].cards[2].image.fileName" :alt="localContent[1].cards[2].image.title">
          <div class="Blurb Blurb--dark mt-3">
            <h2 class="Card-title">{{ localContent[1].cards[2].title }}</h2>
            <h3 class="Card-subheading mt-3">{{ localContent[1].cards[2].subheadings[0] }}</h3>
            <p class="Blurb-body text-center text-lg-left">{{ localContent[1].cards[2].description }}</p>

            <a :href="localContent[1].cards[2].button.link" target="_blank" rel="noopener">
              <button class="Button Button--dark my-3 mx-auto">{{ localContent[1].cards[2].button.text }}</button>
            </a>

            <p>Or send your check directly to:</p><address class="Blurb-blockquote">Living with Wolves <br>Box 896 <br>Sun Valley, Idaho 83353</address>

            <h3 class="Card-subheading mt-3">{{ localContent[1].cards[2].subheadings[1] }}</h3>
            <p class="my-3 text-center text-lg-left">Please contact us if you’d like to learn about estate planning or would like to make a gift to the Living with Wolves Endowment.</p>

            <h3 class="Card-subheading mt-3">{{ localContent[1].cards[2].subheadings[2] }}</h3>
            <p class="text-center text-lg-left">If you would like to speak to someone privately about a donation, please contact us at: <a href="mailto:info@livingwithwolves.org" class="LinkInline">info@livingwithwolves.org</a></p>

          </div>
        </div>
        <!-- end card three -->
      </div>

    </div>
  </div>
</template>

<script>
import appBackground from './../partials/background'
export default {
  name: 'take-action',

  components: {
    appBackground
  },

  data () {
    return {
      localContent: [
        {
          intro: ''
        },
        {
          cards: [
            { // card one
              image: {
                fileName: '',
                title: ''
              },
              title: '',
              subheadings: [
                '',
                '',
                '',
                ''
              ],
              socialLinks: [],
              buttons: [
                {
                  text: '',
                  link: ''
                },
                {
                  text: '',
                  link: ''
                },
                {
                  text: '',
                  link: ''
                },
                {
                  text: '',
                  link: ''
                }
              ]
            },
            { // card two
              image: {
                fileName: '',
                title: ''
              },
              title: '',
              description: '',
              subheadings: [
                ''
              ],
              actions: [],
              button: {
                text: '',
                link: ''
              }
            },
            { // card three
              image: {
                fileName: '',
                title: ''
              },
              title: '',
              description: '',
              subheadings: [
                '',
                ''
              ],
              button: {
                text: '',
                link: ''
              }
            }
          ]
        }
      ]
    }
  },

  computed: {
    sharedContent () {
      return this.$store.getters.sharedContent
    }
  },

  methods: {
    getLocalData (fileName) {
      this.$http.get('./static/data/' + fileName + '.json')
      .then(response => {
        return response
      })
      .then(data => {
        this.localContent = data.body
      })
      .catch(err => {
        console.log(err)
      })
    }
  },

  created () {
    this.getLocalData('takeAction')
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

.Card-title {
  color: $gold;
  text-align: center;
}

.Card-subheading {
  color: $offwhite;
  text-align: center;
}

.Social-list {
  display: flex;
  justify-content: space-around;
  max-width: 245px;
}

.Social-list-item {
  width: 35px;
  & path.icon {
    transition: $transitionHover;
  }
  &:hover path.icon,
  &:hover circle.icon  {
    fill: $gold;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/routes/take-action.vue